<div>
  <div class="border-bottom pb-2">
    @if (daysRemaining > 0 && daysActivation <= 0) {
    <p>
      <strong>
        {{ daysRemaining }}
        <sup>GG</sup>
      </strong>
    </p>
    } @if (daysRemaining <= 0 && daysActivation <= 0) {
    <div>
      <mat-chip-option color="warn" selected>Scaduto</mat-chip-option>
    </div>
    } @if (daysActivation > 0) {
    <div>
      <mat-chip-option color="warn" selected>Non attivata</mat-chip-option>
    </div>
    }
  </div>

  <div class="mt-2">
    @if (status.widgetData.activationDate) {
    <p>
      <span class="mat-caption">Data attivazione</span>
      <strong>
        {{ status.widgetData.activationDate | date : 'shortDate' }}
      </strong>
    </p>
    } @if (status.widgetData.expirationDate) {
    <p>
      <span class="mat-caption">Data scadenza</span>
      <strong>
        {{ status.widgetData.expirationDate | date : 'shortDate' }}
      </strong>
    </p>
    }
  </div>
</div>
